// extracted by mini-css-extract-plugin
export var infoRow = "_jk-2";
export var labelContainer = "_jk-0";
export var rightInfo = "_jk-1";